export default (entities) => ({
  getSalesOrders(organisationId) {
    return entities.SalesOrder.findAll(organisationId);
  },
});
